import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import prefetchDetectedMarket from 'graphql/prefetchers/prefetchDetectedMarket'
import { searchClient } from 'lib/algolia'
import { colorsSecondary200 } from 'lib/theme'
import { NextPage } from 'next'
import { InstantSearch } from 'react-instantsearch-dom'
import { useDebounce } from 'use-debounce'

import PotentialProfileSuggestionForm from 'components/PotentialProfileSuggestionForm/PotentialProfileSuggestionForm'
import PublicLayout from 'components/PublicLayout/PublicLayout'
import SearchHeader from 'components/SearchHeader/SearchHeader'
import Wrapper from 'components/Wrapper/Wrapper'
import useAlgoliaIndices from 'hooks/useAlgoliaIndices'
import useRouter from 'hooks/useRouter'

import Seo from '../../../components/CmsPage/Seo'

type UpdatedSearchStateProps = {
  query: string | string[]
}

const SuggestPage: NextPage = () => {
  const router = useRouter()
  const { profilesIndex } = useAlgoliaIndices()
  const [searchState, setSearchState] = useState({
    query: router.query.searchTerm,
  })
  const [debouncedSearchState] = useDebounce(searchState, 500)

  useEffect(() => {
    if (debouncedSearchState.query !== router.query.searchTerm) {
      router.replace(`/search?q=${debouncedSearchState.query}`)
    }
    if (searchState.query === '') {
      router.replace('/search')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchState, searchState])

  const onSearchStateChange = (updatedSearchState: UpdatedSearchStateProps) => {
    if (updatedSearchState.query !== searchState.query) {
      window.scrollTo(0, 0)
    }
    if (updatedSearchState.query) {
      setSearchState(updatedSearchState)
    } else if (updatedSearchState.query === '') {
      setSearchState({ query: '' })
    } else if (!updatedSearchState.query && router.query.searchTerm) {
      setSearchState({ query: router.query.searchTerm })
    }
  }

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={profilesIndex}
      searchState={searchState}
      onSearchStateChange={onSearchStateChange}
    >
      <PublicLayout
        headerBackground={colorsSecondary200}
        headerBorder
        hidePress
        headerContent={<SearchHeader />}
        navigationBarDarkContent
      >
        <Seo />

        <Wrapper>
          <Row gutter={{ md: 36 }}>
            <Col span={24} md={{ span: 14, offset: 5 }}>
              <PotentialProfileSuggestionForm
                initialValues={{ name: router.query.searchTerm?.toString() }}
              />
            </Col>
          </Row>
        </Wrapper>
      </PublicLayout>
    </InstantSearch>
  )
}

SuggestPage.getInitialProps = prefetchDetectedMarket

export default SuggestPage
